import { gql } from "@apollo/client";
export const LOCKER_TIME_LIMIT = gql`
	query ($operatorId: ID!, $lockerTypeId: ID!, $partnerTypeId: ID!) {
		lockerPartnerLimits(
			operatorId: $operatorId
			lockerTypeId: $lockerTypeId
			partnerTypeId: $partnerTypeId
		) {
			lockerPartnerLimitId
			pickupTakebackLimit
			pickupPulloutLimit
			shipoutBookingExpiry
			shipoutTakebackLimit
			shipoutPulloutLimit
		}
	}
`;

export const LOCKER_TYPES_FOR_LOCKER_TIME_LIMITS = gql`
	{
		lockerTypes {
			lockerTypeId
			lockerType
		}
	}
`;

export const PARTNER_TYPES_FOR_LOCKER_TIME_LIMITS = gql`
	query ($operatorId: ID!, $lockerTypeIds: [Int]) {
		partnerTypes(operatorId: $operatorId, lockerTypeIds: $lockerTypeIds) {
			partnerTypeId
			partnerType
			partnerCategory {
				partnerCategory
				partnerCategoryNo
			}
			__typename
		}
	}
`;

// export const UPDATE_LOCKER_TIME_LIMITS = gql`
//   mutation (
//     $operatorId: Int!
//     $lockerTypeId: Int!
//     $partnerTypeId: Int!
//     $lockerPartnerLimitId: Int!
//     $pickupPulloutLimit: Int!
//     $pickupTakebackLimit: Int!
//     $shipoutBookingExpiry: Int!
//     $shipoutPulloutLimit: Int!
//     $shipoutTakebackLimit: Int!
//   ) {
//     updateLockerTime(
//       operatorId: $operatorId
//       lockerTypeId: $lockerTypeId
//       partnerTypeId: $partnerTypeId
//       lockerPartnerLimitId: $lockerPartnerLimitId
//       pickupPulloutLimit: $pickupPulloutLimit
//       pickupTakebackLimit: $pickupTakebackLimit
//       shipoutBookingExpiry: $shipoutBookingExpiry
//       shipoutPulloutLimit: $shipoutPulloutLimit
//       shipoutTakebackLimit: $shipoutTakebackLimit
//     ) {
//       lockerPartnerLimit {
//         lockerPartnerLimitId
//       }
//     }
//   }
// `;

export const UPDATE_LOCKER_TIME_LIMITS = gql`
	mutation (
		# $operatorId: Int!
		# $lockerTypeId: Int!
		# $partnerTypeId: Int!
		$lockerPartnerLimitId: Int!
		$pickupPulloutLimit: Int!
		$pickupTakebackLimit: Int!
		$shipoutBookingExpiry: Int!
		$shipoutPulloutLimit: Int!
		$shipoutTakebackLimit: Int!
	) {
		updateLockerTime(
			# operatorId: $operatorId
			# lockerTypeId: $lockerTypeId/
			# partnerTypeId: $partnerTypeId
			lockerPartnerLimitId: $lockerPartnerLimitId
			pickupPulloutLimit: $pickupPulloutLimit
			pickupTakebackLimit: $pickupTakebackLimit
			shipoutBookingExpiry: $shipoutBookingExpiry
			shipoutPulloutLimit: $shipoutPulloutLimit
			shipoutTakebackLimit: $shipoutTakebackLimit
		) {
			lockerPartnerLimit {
				lockerPartnerLimitId
			}
		}
	}
`;

export const CREATE_LOCKER_TIME = gql`
	mutation (
		$operatorId: Int!
		$lockerTypeId: Int!
		$partnerTypeId: Int!
		# $lockerPartnerLimitId: Int!
		$pickupPulloutLimit: Int!
		$pickupTakebackLimit: Int!
		$shipoutBookingExpiry: Int!
		$shipoutPulloutLimit: Int!
		$shipoutTakebackLimit: Int!
	) {
		createLockerTime(
			operatorId: $operatorId
			lockerTypeId: $lockerTypeId
			partnerTypeId: $partnerTypeId
			# lockerPartnerLimitId: $lockerPartnerLimitId
			pickupPulloutLimit: $pickupPulloutLimit
			pickupTakebackLimit: $pickupTakebackLimit
			shipoutBookingExpiry: $shipoutBookingExpiry
			shipoutPulloutLimit: $shipoutPulloutLimit
			shipoutTakebackLimit: $shipoutTakebackLimit
		) {
			lockerPartnerLimit {
				lockerPartnerLimitId
			}
		}
	}
`;
